import { lazy } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import MainLayout from "../layout/mainLayout";
import { useState, useEffect } from "react";

const Userole = sessionStorage.getItem("userType");

const Dashboard = lazy(() => import("../pages/Dashboard/dashboard"));
const Products = lazy(() => import("../pages/Products/products"));
const AddEditProduct = lazy(() => import("../pages/Products/addEditProduct"));
const Orders = lazy(() => import("../pages/Orders/orders"));
const B2BOrders = lazy(() => import("../pages/B2bOrders/b2bOrders"));
const B2BOrderView = lazy(() => import("../pages/B2bOrders/orderView"));
const Promos = lazy(() => import("../pages/Promo/promo"));
const AddPromo = lazy(() => import("../pages/Promo/addPromo"));
const Loyalty = lazy(() => import("../pages/Loyalty/loyalty"));
const Notifications = lazy(() => import("../pages/Notifications/notifications"));
const Profile = lazy(() => import("../pages/Profile/profile"));
const B2BPlaceOrder = lazy(() => import("../pages/B2bPlaceOrder/index"));
const RefineryView = lazy(() => import("../pages/B2bPlaceOrder/refineryView"));
const Checkout = lazy(() => import("../pages/B2bPlaceOrder/checkout"));
const OrderSuccess = lazy(() => import("../pages/B2bPlaceOrder/orderSuccess"));

const Driver = lazy(() => import("../pages/Driver/index"));
const AddEditDriver = lazy(() => import("../pages/Driver/addEditDriver.jsx"));

const Services = lazy(() => import("../pages/Services/services"));
const AddEditService = lazy(() => import("../pages/Services/addServices"));


const UserChecker = ({ allowedRoles }) => {
  const location = useLocation();
  const [userRole, setUserRole] = useState(sessionStorage.getItem("userType"));

  useEffect(() => {
    setUserRole(sessionStorage.getItem("userType"));
  }, [location]); // re-check when route changes

  return allowedRoles.includes(userRole) ? <Outlet /> : <Navigate to="/home/dashboard" replace />;
};

const LoginChecker = () => {
  const location = useLocation();
  const [loginCheck, setLoginCheck] = useState(sessionStorage.getItem("refreshToken") ? true : false);

  useEffect(() => {
    setLoginCheck(sessionStorage.getItem("refreshToken") ? true : false);
  }, [location]); // re-check when route changes

  return loginCheck ? <Outlet /> : <Navigate to="/" replace />;
};

export const privateRoutes = [
  {
    path: "/home",
    element: <LoginChecker />,
    children: [
      {
        element: <MainLayout />, // now MainLayout is rendered only if logged in
        children: [
          { index: true, element: <Navigate to="dashboard" replace /> },
          { path: "dashboard", element: <Dashboard /> },
          { path: "products", element: <Products /> },
          { path: "add-edit-products", element: <AddEditProduct /> },
          { path: "orders", element: <Orders /> },
          { path: "notifications", element: <Notifications /> },
          { path: "profile", element: <Profile /> },
          { path: "b2b", element: <B2BOrders /> },
          { path: "b2b-order-view", element: <B2BOrderView /> },
          // Fuel Station Only
          {
            element: <UserChecker allowedRoles={["fuel_station"]} userRole={Userole} />,
            children: [
              { path: "promos", element: <Promos /> },
              { path: "loyalty", element: <Loyalty /> },
              { path: "place-order", element: <B2BPlaceOrder /> },
              { path: "refinery-view", element: <RefineryView /> },
              { path: "checkout", element: <Checkout /> },
              { path: "order-success", element: <OrderSuccess /> },
              { path: "services", element: <Services /> },
              { path: "add-services", element: <AddEditService /> },
              { path: "add-promo", element: <AddPromo /> },
            ],
          },

          // Refinery Only
          {
            element: <UserChecker allowedRoles={["refinery"]} userRole={Userole} />,
            children: [
              { path: "driver", element: <Driver /> },
              { path: "add-edit-driver", element: <AddEditDriver /> },
            ],
          },
        ],
      },
    ],
  },
];

